import { Money, type Currency } from '@chukua/common';

export type MoneyAmountCheck = { ok: true; amountMinor: number } | { ok: false; reason: string };

/** An amount as typed in major units ("12,500.50") to the integer minor units the API stores, more than zero; a float never reaches the wire. */
export function parseMoneyAmount(raw: string | undefined, currency: Currency): MoneyAmountCheck {
  const typed = (raw ?? '').replace(/[,\s]/g, '');
  if (typed === '') return { ok: false, reason: 'Enter the amount' };
  try {
    const { amountMinor } = Money.parse(typed, currency).toJSON();
    return amountMinor > 0 ? { ok: true, amountMinor } : { ok: false, reason: 'The amount must be more than zero' };
  } catch {
    return { ok: false, reason: `Enter a number with at most the decimals ${currency} uses` };
  }
}
